






















import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import setTemplate from "./setTemplate.vue";
import ajax from "@/lib/ajax";
import util from "@/lib/util";

@Component({
  components: { setTemplate },
})
export default class extends AbpBase {
  form: any = {};
  setTemplateShow: boolean = false;
  sendResult: string = ""; // 发送结果
  sendResultShow: boolean = false; // 发送结果弹窗

  // 获取短信内容
  get messageContent() {
    return util.abp.setting.get("MobileMsgTempForPatient");
  }

  // 清空手机号
  clearMobiles() {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要清空吗？",
      onOk: () => {
        this.form.mobiles = "";
      },
    });
  }

  // 模板维护
  setTemplate() {
    this.setTemplateShow = true;
  }

  // 短信发送
  sendMessage() {
    if (!this.form.mobiles) {
      this.$Message.error("请输入手机号");
      return;
    }

    // 调用接口发送短信
    this.$message.info("发送中，请稍后。。。");
    this.$Loading.start();
    let mobiles = this.form.mobiles.split("\n");
    let payload = {
      messageContent: this.messageContent,
      mobiles: mobiles,
    };
    ajax
      .post(SYNC_SMS_URL, payload, { timeout: 600000 })
      .then((res: any) => {
        this.$Loading.finish();
        this.sendResult = res.data.message;
        this.sendResultShow = true;
      })
      .catch((err) => {
        console.error(err);
        this.$Loading.error();
        this.$Modal.error({
          title: "提示",
          content: "发送异常",
        });
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/mobileMessage/index.vue